
export enum AnalyticsInterfaceType {
	Mobile = 0,
	Desktop = 1,
}

export enum AnalyticsScreenNameId {
	Overview = 1,
	Missions = 2,
	Leaderboards = 3,
	Tournaments = 4,
	TournamentLobby = 5,
	Levels = 6,
	LevelsMap = 7,
	Badges = 8,
	Bonuses = 9,
	SpinAWheel = 10,
	Store = 11,
	StoreHistory = 12,
	Inbox = 13,
	MatchX = 14,
	Quiz = 15,
	Jackpots = 16,
	Lootbox = 17,
	CustomSection = 18,
	ShortInbox = 19,
	LootboxWeekdays = 20,
	LootboxCalendarDays = 21,
	TreasureHunt = 22,
	LiquidSection = 23,
	ActivityLog = 24,
	MiniGamesHistory = 25,

	ModalMission = 31,
	ModalLevel = 32,
	ModalBadge = 33,
	ModalStore = 34,
	ModalBonus = 35,
	ModalJackpot = 36,
	ModalUsername = 37,
	ModalAvatar = 38,
	ModalQR = 39,
}

export enum AnalyticsTournamentsLobbySubScreenNameId {
	General = 1,
	Prizes = 2,
	Players = 3,
	RelatedGames = 4,
}

export enum AnalyticsInboxSubScreenNameId {
	All = 1,
	Favorite = 2,
}
